import { render } from "./PrInput.vue?vue&type=template&id=4ad2fd3e&scoped=true"
import script from "./PrInput.vue?vue&type=script&lang=js"
export * from "./PrInput.vue?vue&type=script&lang=js"

import "./PrInput.vue?vue&type=style&index=0&id=4ad2fd3e&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad2fd3e"]])

export default __exports__